import { observer } from 'mobx-react';
import React from 'react';

import { NeighborButtons } from 'components/UI/NeighborButtons';
import store from 'stores/RootStore';

function NavigationMenu() {
  const tearsheetAdsManager = store.tearsheet?.ads;
  const previousAd = tearsheetAdsManager?.previous;
  const nextAd = tearsheetAdsManager?.next;

  // Navigate rather than select: the route selects the ad, so the URL, the
  // viewed ad and the list highlight all follow from one place.
  return (
    <NeighborButtons
      previous={{
        disabled: !previousAd,
        onClick: () => previousAd?.navigateTo(),
      }}
      next={{ disabled: !nextAd, onClick: () => nextAd?.navigateTo() }}
    />
  );
}

export default observer(NavigationMenu);
